module.exports = __webpack_public_path__ + "img/main-visual_btn.73d3827b.svg";